import en from '../../../lang/en-us';
import { transmissionPdf } from '../../../redux-store/actions/link';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { TransmissionFormType } from '.';
import { useEffect } from 'react';
import moment from 'moment';
import { ActionHeader } from '../../dashboard/makeNct';
import { fileDownload } from '../../../lib/FileDownload';
const { dashboard } = en;
export interface StateProps extends TransmissionFormType {
    reqId: string;
    data: any;
}
interface TransmissionRequestSuccessProps extends RouteComponentProps<any, any, StateProps> {
    transmissionPdf: (body: any) => Promise<any>;
}

function TransmissionRequestSuccess(props: TransmissionRequestSuccessProps) {
    const { email, name, mobile, pan, reqId, data } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state || !reqId) {
            props.history.replace('/');
        }
    }, []);

    // console.log('transmission-request-success', props);

    const handleSubmit = async () => {
        try {
            const payload: any = {
                email,
                claimantName: name,
                mobile,
                pan,
                reqId,
                data: [...data],
            };
            let res = await props.transmissionPdf(payload);
            return fileDownload({
                data: res.body,
                filename: `transmission${moment().format('YYYY_MM_DD_HHmmss')}.pdf`,
            });
        } catch (err: any) {
            alert(err.message);
        }
    };
    return (
        <div className="curved-bg">
            {/* <ActionHeader header={dashboard.TransmissionRequest.success.back} /> */}
            <h2 className="heading">
                <a
                    role="button"
                    tabIndex={0}
                    aria-label="Go back"
                    onClick={() => props.history.goBack()}
                    onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            props.history.goBack();
                        }
                    }}
                >
                    <img src="/images/left-arrow-black.svg" alt="" aria-hidden="true" />
                </a>
                {dashboard.TransmissionRequest.success.back}
            </h2>
            <div className="curved-bg-content nct-success-screen transmission-success">
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <img
                            className="change-email-img"
                            src="/images/portfolio-banner-character.png"
                            alt=""
                        />
                        <h3 className="subheading">
                            {dashboard.TransmissionRequest.success.success}
                        </h3>
                        <p>
                            {dashboard.TransmissionRequest.success.info1}
                            <span>{reqId}</span>
                            {dashboard.TransmissionRequest.success.info2}
                        </p>
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <a onClick={handleSubmit}>Click Here </a>
                        <p>{dashboard.TransmissionRequest.success.submitFormInfo}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(null, { transmissionPdf })(TransmissionRequestSuccess);
